import { FC, useCallback } from 'react';

import { SetScreenType } from 'src/components/Modals/TemplateGallery/index';
import { TemplateGalleryTemplatesList } from 'src/components/Modals/TemplateGallery/components/TemplatesList';
import { useNsTHelper } from 'src/utils/i18n';
import styles from 'src/styles/common/templateGallery.module.scss';
import { TemplateGalleryLinkButton } from 'src/components/Modals/TemplateGallery/components/LinkButton';
import { TemplateGalleryMostUsedListType } from 'src/models/Modals/templateGallery';
import { useAnyRequestState } from 'src/utils/hooks/useAnyRequestState';
import { apiGetFeaturedTemplates } from 'src/api/organizerTemplate';
import { UiLoader } from 'src/components/UI/loaders';
import { BaseSeparateModal } from 'src/models/modals';
import { UiButton } from 'src/components/UI/Button';
import { useSelector } from 'react-redux';
import { deCommonCurrentPartnerSelector } from '../../../../store/commonPart/selector';

type Props = BaseSeparateModal & {
  setScreen: SetScreenType;
  calledFrom: string | null;
};

export const TemplateGalleryMainScreen: FC<Props> = ({ setScreen, calledFrom, onClose }) => {
  const tHelper = useNsTHelper('modals.templateGallery', 'main');

  const { CampaignTerminologySingular } = useSelector(deCommonCurrentPartnerSelector);

  const [model] = useAnyRequestState<TemplateGalleryMostUsedListType>(null, {
    data: {
      OverridenOrganizationID: window.managedCampaignSettings?.organizationId,
      OverridenUserID: window.managedCampaignSettings?.userId,
    },
    apiFunction: apiGetFeaturedTemplates,
  });

  const goToAllScreen = useCallback(() => setScreen('all'), [setScreen]);

  return (
    <>
      <div className={styles.setupSubhead}>
        <div className={styles.heading1}>
          {tHelper('setupSubhead.continueTitle', { campaignSingularTerminology: CampaignTerminologySingular })}
        </div>

        {calledFrom === 'FromCampaignSetup' && (
          <div>
            <div className={styles.continueButtonContainer}>
              <UiButton secondaryBordered className="btn btn-border-default text-transform-none" onClick={onClose}>
                <div className={styles.name}>{tHelper('setupSubhead.continueButton')}</div>
              </UiButton>
            </div>

            <div className={styles.explanation1}>{tHelper('setupSubhead.continueExplanation')}</div>

            <div className={styles.orLine}>
              <div className={styles.line} />
              <div className={styles.or}>or</div>
              <div className={styles.line} />
            </div>
          </div>
        )}

        <div className={styles.heading2}>{tHelper('setupSubhead.exploreTemplates')}</div>
        <div className={styles.explanation2}>{tHelper('setupSubhead.exploreTemplatesExplanation')}</div>
      </div>

      {model ? (
        <div className={styles.templates}>
          <TemplateGalleryTemplatesList setScreen={setScreen} items={model} smallIcons />
        </div>
      ) : (
        <div className={`${styles.templates} ${styles.loading}`}>
          <UiLoader className={styles.loader} centered />
        </div>
      )}

      <TemplateGalleryLinkButton onClick={goToAllScreen} className={styles.linkButtonCentered}>
        {tHelper('browseAll')}
      </TemplateGalleryLinkButton>
    </>
  );
};
